import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { IBreadCrumbLink } from "../../shared/dto/IBreadcrumbDto";
import styled from "styled-components";
import { withRouter } from "react-router";

class BreadCrumb extends React.Component<any, any> {
  render() {
    const { breadCrumbList, location } = this.props;
    return (
      <div style={{ display: "flex" }}>
        {breadCrumbList.map(
          ({ label, to, noLink, relative }: IBreadCrumbLink, index: number) => {
            return (
              <Fragment key={index}>
                {to ? (
                  <>
                    {relative ? (
                      <StyledLink to={{pathname:to, search: location.search}}>
                        {label} <i className="icon-cwb-chevron"></i>
                      </StyledLink>
                    ) : (
                      <StyledAnchor href={to}>
                        {label} <i className="icon-cwb-chevron"></i>
                      </StyledAnchor>
                    )}
                  </>
                ) : noLink ? (
                  <StyledAnchor>
                    {label} <i className="icon-cwb-chevron"></i>
                  </StyledAnchor>
                ) : (
                  <StyledSpan>{label}</StyledSpan>
                )}
              </Fragment>
            );
          }
        )}
      </div>
    );
  }
}

const StyledAnchor = styled.a`
  &&&,
  &:hover {
    display: flex;
    color: ${(p) => p.theme.kiosk.bdColor};
    font-size: ${(p) => p.theme["font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
    text-decoration: none;
    line-height: 19px;
  }

  i {
    font-size: ${(p) => p.theme["sm-cb-font"]};
    margin: 0 8px;
    line-height: 19px;
  }
`;

const StyledLink = StyledAnchor.withComponent(Link);

const StyledSpan = styled.span`
  &&&,
  &:hover {
    display: flex;
    color: ${(p) => p.theme.kiosk.bdColor};
    font-size: ${(p) => p.theme["font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
    text-decoration: underline;
    line-height: 19px;
  }
`;

export default withRouter(BreadCrumb);
